import { getAccessToken } from '@driftt/web-auth';
import { Socket } from 'phoenix';
import { AsyncSubject, EMPTY, timer } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map, mergeMap, retryWhen, scan } from 'rxjs/operators';
const RECONNECT_SOCKET_TIMES = [10, 50, 100, 150, 200, 250, 500, 1000, 2000];
const REJOIN_CHANNEL_TIMES = [1000, 2000, 5000];
export class DriftWebSocketConnection {
  constructor(baseUrl, clusterName, orgId, store) {
    this.baseUrl = baseUrl;
    this.clusterName = clusterName;
    this.orgId = orgId;
    this.store = store;
    this.subscribe = fun => {
      return this.socketConnection.subscribe(fun);
    };
    this.socketConnection = this.open();
  }
  get shardId() {
    return this.orgId % 50;
  }
  get url() {
    return `${this.orgId}-${this.shardId}.${this.baseUrl}`;
  }
  get wssBaseUrl() {
    return `wss://${this.url}/ws`;
  }
  get apiBaseUrl() {
    return `https://${this.url}`;
  }
  get authParams() {
    return {
      access_token: getAccessToken()
    };
  }
  auth() {
    return ajax({
      url: `${this.apiBaseUrl}/api/auth`,
      method: 'POST',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.authParams)
    }).pipe(retryWhen(errors => {
      return errors.pipe(scan((count, error) => {
        if (count >= 3) {
          throw error;
        }
        return count + 1;
      }, 0), mergeMap(count => timer(2 ^ count * 1000)));
    }), map(data => {
      return Object.assign({}, data.response);
    }), catchError(() => {
      return EMPTY;
    }));
  }
  open() {
    const sub = new AsyncSubject();
    const obs = this.auth().pipe(map(authResponse => {
      const socket = new Socket(this.wssBaseUrl, {
        params: {
          session_token: authResponse.session_token
        },
        timeout: 20000,
        reconnectAfterMs: attempt => {
          const timeUntilReconnect = RECONNECT_SOCKET_TIMES[attempt - 1] || 5000;
          return timeUntilReconnect;
        },
        rejoinAfterMs: attempt => {
          return REJOIN_CHANNEL_TIMES[attempt - 1] || 10000;
        }
      });
      socket.onClose(() => {});
      socket.onError(() => {});
      socket.connect();
      return socket;
    }));
    obs.subscribe(x => {
      sub.next(x);
    }, err => {
      sub.error(err);
    }, () => {
      sub.complete();
    });
    return sub;
  }
}